<template>
  <div>
    <vs-tabs v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.name" :label="tab.label" @click="onClickTab(tab)" />
    </vs-tabs>

    <vs-card>
      <div class="p-4">
        <div class="flex justify-between">
          <span class="col-span-2 md:col-span-1" style="font-weight: 700; font-size: 18px">회원관리</span>
          <div class="flex gap-2">
            <vs-button v-if="myInfo && (myInfo.can_manage_pending_user || myInfo.is_superuser)" color="secondary" type="border" @click="onClickRemove">회원삭제</vs-button>
            <vs-button color="secondary" type="border" @click="onClickClose">닫기</vs-button>
            <vs-button v-if="editMode && myInfo && (myInfo.can_manage_pending_user || myInfo.is_superuser)" color="secondary" @click="onClickSave">변경사항 저장</vs-button>
          </div>
        </div>

        <h5 class="my-4"><i class="dot"></i> 회원구분</h5>
        <div class="grid-container mb-8">
          <radio-group class="col-span-4 my-2" flex :items="registerTypeList" :row-count="2" v-model="pendingUser.meta.registerType" @input="fixRegisterType" />
        </div>

        <h5 class="my-4"><i class="dot"></i> 작업자 정보</h5>
        <div class="grid-container">
          <input-form class="grid-item" label="사업장명">
            <vs-select class="w-full" v-model="pendingUser.meta.field" :options="fieldOptions" autocomplete placeholder="사업장을 선택해주세요.">
              <vs-select-item v-for="item in fieldOptions" :key="item.id" :value="item" :text="item.field_name" />
            </vs-select>
          </input-form>
          <input-form class="grid-item" label="동국제강 담당부서">
            <label class="w-full" style="display: grid; grid-template-columns: 1fr; gap: 0.675rem">
              <ml-input class="w-full" placeholder="담당부서명을 입력해주세요." v-model="pendingUser.meta.담당부서" />
            </label>
          </input-form>

          <!-- 일용직 회원의 경우 업체검색 폼이 나타나지 않도록 함 -->
          <input-form v-if="pendingUser.meta.registerType !== 일용직.value" class="grid-item" label="업체명(사업자등록번호)" :error-message="error.업체">
            <div
              v-if="pendingUser.meta.업체 && pendingUser.meta.업체.id && pendingUser.meta.업체.id !== '' && pendingUser.meta.업체.com_name && pendingUser.meta.업체.com_name !== ''"
              class="align-center"
              style="display: grid; grid-template-columns: 1fr 1fr auto; gap: 0.675rem; align-items: start"
            >
              <ml-input class="w-full" v-model="pendingUser.meta.업체.com_name" readonly />
              <ml-input class="w-full" v-model="pendingUser.meta.업체.com_number" :danger="isDanger업체" readonly />
              <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="popupAssign담당부서 = true">업체 변경</vs-button>
            </div>
            <label v-else class="w-full" style="display: grid; grid-template-columns: 1fr auto; gap: 0.675rem; align-items: start">
              <ml-input class="w-full" v-model="pendingUser.meta.업체.com_name" :danger="isDanger업체" readonly />
              <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="popupAssign담당부서 = true">업체 검색</vs-button>
            </label>
          </input-form>
        </div>
        <div class="grid-container mt-4">
          <input-form class="grid-item" label="아이디">
            <label class="w-full" style="gap: 0.675rem">
              <ml-input class="w-full" placeholder="아이디 입력" v-model="pendingUser.username" readonly />
            </label>
          </input-form>
          <input-form class="grid-item" label="비밀번호">
            <template v-if="resetPassword">
              <vs-button class="px-3" color="secondary" type="border" tabindex="-1" @click="onClickResetPassword">비밀번호 초기화 취소</vs-button>
              <span class="text-sm mt-2 text-gray-500">비밀번호 변경을 취소합니다.</span>
            </template>
            <template v-else>
              <vs-button class="px-3" color="danger" type="border" tabindex="-1" @click="onClickResetPassword">비밀번호 초기화(ID와 동일)</vs-button>
              <span class="text-sm mt-2 text-danger">클릭하고 저장하면 비밀번호를 아이디와 동일하게 초기화합니다</span>
            </template>
          </input-form>

          <input-form class="grid-item gap-2" label="내국인/외국인">
            <radio-group
              class="col-span-4 my-2"
              flex
              :items="[
                { label: '내국인', value: false },
                { label: '외국인', value: true },
              ]"
              :row-count="2"
              v-model="pendingUser.meta.isForeigner"
              readonly
            />
          </input-form>
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="이름">
            <ml-input class="w-full" v-model="pendingUser.name" />
          </input-form>
          <input-form class="grid-item" :label="pendingUser.meta.isForeigner ? '외국인등록번호(앞 7자리 한정)' : '주민등록번호(앞 7자리 한정)'">
            <ml-input class="w-full" v-model="formatRRN" readonly />
          </input-form>

          <input-form class="grid-item" label="휴대폰번호">
            <div class="flex gap-2">
              <ml-input class="w-full" v-model="pendingUser.phone1" :max="3" readonly />
              <span style="align-content: center">-</span>
              <ml-input class="w-full" v-model="pendingUser.phone2" :max="4" readonly />
              <span style="align-content: center">-</span>
              <ml-input class="w-full" v-model="pendingUser.phone3" :max="4" readonly />
            </div>
          </input-form>
          <input-form class="grid-item" label="이메일" :error-message="error.이메일">
            <ml-input class="w-full" v-model="pendingUser.email" :danger="isDanger이메일" />
          </input-form>

          <!--          <input-form class="grid-item" label="주소">-->
          <!--            <address-field class="w-full" v-model="pendingUser.meta.address" :visible-zip-code="false" />-->
          <!--          </input-form>-->
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="직책">
            <ml-input class="w-full" v-model="pendingUser.직책" placeholder="직책을 입력해주세요." />
          </input-form>
          <input-form class="grid-item" label="직종">
            <ml-input class="w-full" v-model="pendingUser.meta.직종" placeholder="예) 전기기사 등" />
          </input-form>
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="건설업기초안전교육">
            <file-uploader-none-token class="w-full" placeholder="파일을 업로드해주세요." v-model="pendingUser.meta.건설업기초안전교육" readonly />
          </input-form>
          <input-form class="grid-item" label="교육 이수번호">
            <ml-input class="w-full" placeholder="교육 이수번호를 입력해주세요." v-model="pendingUser.meta.교육이수번호" />
          </input-form>

          <input-form class="grid-item" label="서명 등록">
            <div class="h-full" style="border: solid 1px #cdcdcd; border-radius: 6px; background-color: #f4f4f4; max-width: 367px; min-height: 120px">
              <img :src="pendingUser.서명 ? pendingUser.서명.path : ''" alt="" height="120" class="my-1" />
            </div>

            <div class="mt-2">
              <span style="color: #4839eb; font-weight: 400"> ※ 본인 고유의 필체로 자신의 이름을 제 3자가 알아볼 수 있도록 정자로 서명등록 부탁드립니다.<br /> </span>
              <img :src="require('@/assets/images/pages/register/example_sign_col.svg')" alt="example_sign" class="mt-2" style="width: 100%" />
            </div>
          </input-form>
          <input-form class="grid-item" label="신분증 사진">
            <div class="h-full" style="width: 367px; min-height: 120px">
              <img :src="pendingUser.meta.enc.신분증사진 && pendingUser.meta.enc.신분증사진 !== '' ? pendingUser.meta.enc.신분증사진 : require(`@/assets/images/checker.svg`)" alt="" height="120" class="my-1" />
            </div>

            <div class="mt-2">
              <span style="color: #4839eb; font-weight: 400"> ※ 주민등록번호 뒷자리는 가려서 촬영해주세요. </span>
              <img :src="require('@/assets/images/pages/register/example_identification_col.svg')" alt="example_identification" class="mt-2" style="width: 100%" />
            </div>
          </input-form>
        </div>

        <h5 class="my-4"><i class="dot"></i> 작업자 정보</h5>
        <div class="grid-container">
          <div class="col-span-2 md:col-span-1">
            <input-form class="grid-item mb-6" label="안전교육 만료일" rightText="※관리자 입력">
              <template #label="{label, rightText}">
                <span class="pb-1" style="font-weight: 500; min-height: 24.5px">
                  {{ label }}:
                  <span class="text-danger">{{교육만료일.기본안전 || "(미수강)"}}, </span>
                  <span v-if="rightText" class="right-text">{{ rightText }}</span>
                </span>
              </template>
              <DateSelector :readonly="!isAdmin" class="w-full" placeholder="날짜선택" v-model="pendingUser.meta.안전교육만료일" />
            </input-form>
            <input-form class="grid-item mb-6" label="작업자 안전교육 만료일" rightText="※관리자 입력">
              <template #label="{label, rightText}">
                <span class="pb-1" style="font-weight: 500; min-height: 24.5px">
                  {{ label }}:
                  <span class="text-danger">{{교육만료일.작업자 || "(미수강)"}}, </span>
                  <span v-if="rightText" class="right-text">{{ rightText }}</span>
                </span>
              </template>
              <DateSelector :readonly="!isAdmin" class="w-full" placeholder="날짜선택" v-model="pendingUser.meta.작업자안전교육만료일" />
            </input-form>
            <input-form class="grid-item" label="밀폐공간 안전교육 만료일" rightText="※관리자 입력">
              <template #label="{label, rightText}">
                <span class="pb-1" style="font-weight: 500; min-height: 24.5px">
                  {{ label }}:
                  <span class="text-danger">{{교육만료일.밀폐공간 || "(미수강)"}}, </span>
                  <span v-if="rightText" class="right-text">{{ rightText }}</span>
                </span>
              </template>
              <DateSelector :readonly="!isAdmin" class="w-full" placeholder="날짜선택" v-model="pendingUser.meta.밀폐공간안전교육만료일" />
            </input-form>
          </div>
          <input-form class="grid-item" label="건강정보(수축/이완)" rightText="※관리자 입력">
            <div class="w-full flex items-center justify-center mb-6">
              <NumberInput :readonly="!isAdmin" class="w-full" placeholder="수축" v-model="pendingUser.meta.수축" />
              <p class="px-2">/</p>
              <NumberInput :readonly="!isAdmin" class="w-full" placeholder="이완" v-model="pendingUser.meta.이완" />
            </div>
            <div class="flex items-center justify-center mb-6 gap-4">
              <input-form class="grid-item flex-1" label="측정일">
                <DateSelector :readonly="!isAdmin" class="w-full" placeholder="날짜선택" v-model="pendingUser.meta.측정일" @input="inputMeasurementDate" />
              </input-form>
              <input-form class="grid-item flex-1" label="유효기간(1년)">
                <DateSelector readonly class="w-full" placeholder="자동입력 (측정일로부터 1년)" v-model="pendingUser.meta.유효기간" />
              </input-form>
            </div>
          </input-form>
        </div>

        <h5 class="my-8 flex"><vs-checkbox v-model="pendingUser.meta.장비운전자" /> 장비운전자</h5>
        <div class="grid-container mt-4">
          <div class="grid-item">
            <span>건설기계 조종사 면허</span>
            <ml-input class="my-1 w-full" v-model="pendingUser.meta.건설기계조종사면허번호" placeholder="지역00-1234-5678-90" />
          </div>
          <div class="grid-item grid">
            <span>면허증 사진</span>
            <div class="h-full" style="width: 367px; min-height: 120px">
              <img
                :src="pendingUser.meta.enc.건설기계조종사면허증사진 && pendingUser.meta.enc.건설기계조종사면허증사진 !== '' ? pendingUser.meta.enc.건설기계조종사면허증사진 : require(`@/assets/images/checker.svg`)"
                alt=""
                height="120"
                class="my-1"
              />
            </div>

            <div>
              <span style="color: #ff0000; font-weight: 400"> ※ 주민등록번호 뒷자리는 가려서 촬영해주세요. </span>
            </div>
          </div>
        </div>
      </div>
    </vs-card>

    <popup-search-company ref="popupSearchCompany" v-model="popupAssign담당부서" @handleClickSelect="handleClickSelectCompany" />
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import HttpRequest from "@/util/HttpRequest";
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";
import FileUploaderNoneToken from "@/components/FileUploaderNoneToken.vue";
import AddressField from "@/components/AddressField.vue";
import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PopupCompanyInfo from "@/views/pages/standing-account/PopupCompanyInfo.vue";
import PopupSearchCompany from "@/popup/PopupSearchCompany.vue";
import { getRegisterTypeInfo, registerTypeList } from "@/views/pages/register/RegisterTypeInfo.js";
import DateSelector from "@/components/selector/DateSelector.vue";
import NumberInput from "@/components/NumberInput.vue";
import {applyEducationExpirationToUser} from "@/util/TrainingVideo";

export default {
  components: {
    PopupSearchCompany,
    PopupCompanyInfo,
    RadioGroup,
    InputForm,
    AddressField,
    FileUploaderNoneToken,
    SignField,
    FileUploader,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
    DateSelector,
    NumberInput,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      isAdmin = isAdmin || parseInt(this.myInfo.is_superuser) > 0;
      return isAdmin;
    },

    tabList() {
      const list = [{ code: 0, name: "page-regist-account-list", label: "회원관리" }];
      return list;
    },

    projectId() {
      return this.$route.params.proj_id;
    },

    getId() {
      return this.$route.params.id;
    },

    formatRRN: {
      get() {
        const rrn = this.pendingUser.meta.rrn;
        if (!rrn || rrn.length !== 7 || isNaN(rrn)) {
          return "";
        }

        const datePart = rrn.slice(0, 6);
        const lastDigit = rrn[6];

        return `${datePart}-${lastDigit}******`;
      },
      set(newValue) {
        const cleanValue = newValue.replace(/[^0-9]/g, "").slice(0, 7);
        this.pendingUser.meta.rrn = cleanValue;
      },
    },

    isDanger업체() {
      if (this.pendingUser.meta.registerType === this.일용직.value) {
        return false;
      }

      if (!this.pendingUser.meta.업체 || this.pendingUser.meta.업체.com_name === "" || this.pendingUser.meta.업체.id === "") {
        this.error.업체 = "업체가 지정되지 않았습니다.";
        return true;
      }

      this.error.업체 = "";
      return false;
    },
    isDanger이메일() {
      // 이메일이 있는경우에만 검사
      if (this.pendingUser.email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(this.pendingUser.email)) {
          this.error.이메일 = "유효하지 않은 이메일 형식입니다.";
          return true;
        }
      }

      this.error.이메일 = "";
      return false;
    },
  },
  data() {
    return {
      tabIndex: 0,
      fieldOptions: [],
      popupAssign담당부서: false,
      registerTypeList,
      일용직: getRegisterTypeInfo("일용직"),

      originPendingUserString: "", // backup original pending user data
      editMode: false,

      // 비밀번호 초기화 여부
      resetPassword: false,

      pendingUser: {
        id: 0,
        username: "",
        name: "",
        phone: "",
        phone1: "",
        phone2: "",
        phone3: "",
        email: "",
        직책: "",
        서명: "",
        registered_at: "",
        rejected_at: "",
        created_at: "",
        updated_at: "",
        meta: {
          registerType: 0,
          field: "",
          담당부서: "",
          업체: {
            com_name: "",
            com_number: "",
          },
          isForeigner: false,
          rrn: "",
          직종: "",
          건설업기초안전교육: "",
          교육이수번호: "",
          enc: {
            신분증사진: "",
            건설기계조종사면허증사진: "",
          },
          장비운전자: false,
          건설기계조종사면허번호: "",

          안전교육만료일: "",
          작업자안전교육만료일: "",
          밀폐공간안전교육만료일: "",
          수축: "",
          이완: "",
          측정일: "",
          유효기간: "",
        },
      },
      error: {
        업체: "",
        이메일: "",
      },
      교육만료일: {
        기본안전: "",
        작업자: "",
        밀폐공간: "",
      }
    };
  },
  async created() {
    this.initBreadcrumb();
    await this.loadFieldList();
    await this.loadUser(this.getId).then((response) => {
      this.originPendingUserString = JSON.stringify(this.pendingUser);
      this.updateEditMode();
    });
  },
  // input-icon-validate 클래스를 가진 엘리먼트에 대해 MutationObserver를 이용하여 자식 엘리먼트가 추가될 때마다 display: none 처리
  mounted() {
    this.$nextTick(() => {
      const iconElements = this.$el.querySelectorAll(".input-icon-validate");
      iconElements.forEach((iconElement) => {
        iconElement.style.display = "none";
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.classList && node.classList.contains("input-icon-validate")) {
                node.style.display = "none";
              }
            });
          }
        });
      });

      observer.observe(this.$el, { childList: true, subtree: true });
    });
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "작업자 관리" }, { title: "회원관리", active: true }]);
    },
    // 업체변경 선택
    handleClickSelectCompany(company) {
      this.pendingUser.meta.업체 = company;
    },
    // 사업장명 검색
    async loadFieldList() {
      await HttpRequest.get("/api/v1/field/pub")
        .then((response) => {
          if (response) {
            this.fieldOptions = response[0].fields.map((data) => {
              return {
                id: data.id,
                field_name: data.field_name,
              };
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    onClickTab(tab) {
      this.tabIndex = tab.code;
      this.$router.push({
        name: tab.name,
        query: this.$route.query,
      });
    },
    onClickRemove() {
      this.customAlert("회원을 삭제하시겠습니까?");
    },
    onClickClose() {
      this.$router.push({
        name: "page-regist-account-list",
        query: this.$route.query,
      });
    },
    onClickCancel() {
      this.pendingUser = JSON.parse(this.originPendingUserString);
      this.fixMissingMetaData();
    },
    onClickSave() {
      if (this.isDanger업체) {
        alert("업체가 지정되지 않았습니다.");
        return;
      }

      if (this.isDanger이메일) {
        alert("유효하지 않은 이메일 형식입니다.");
        return;
      }

      this.loadEditAccount(this.getId);
    },

    fixRegisterType() {
      if (this.pendingUser.meta.registerType === this.일용직.value) {
        this.pendingUser.meta.업체 = { com_name: "", com_number: "" };
      }
    },
    fixMissingMetaData() {
      const metas = this.pendingUser.metas;

      const metaKeys = {
        // 회원구분
        registerType: "registerType",
        // 사업장
        field_id: "field.id",
        field_name: "field.field_name",
        // 담당부서
        담당부서: "담당부서",
        // 업체
        com_name: "업체.com_name",
        com_number: "업체.com_number",
        // 내국인/외국인
        foreign: "is_foreigner",
        // 주민등록번호앞
        rrn: "rrn",
        // 직종
        직종: "직종",
        // 건설업기초안전교육
        건설업기초안전교육_id: "건설업기초안전교육.id",
        건설업기초안전교육_fileName: "건설업기초안전교육.fileName",
        건설업기초안전교육_fileSize: "건설업기초안전교육.fileSize",
        건설업기초안전교육_path: "건설업기초안전교육.path",
        건설업기초안전교육_thumb: "건설업기초안전교육.thumb",
        // 교육이수번호
        교육이수번호: "교육이수번호",
        // 신분증
        신분증: "신분증사진",
        // 장비운전자
        장비운전자: "장비운전자",
        // 건설기계조종사면허
        건설기계조종사면허번호: "건설기계조종사면허번호",
        건설기계조종사면허증: "건설기계조종사면허증사진",

        안전교육만료일: "안전교육만료일",
        작업자안전교육만료일: "작업자안전교육만료일",
        밀폐공간안전교육만료일: "밀폐공간안전교육만료일",
        수축: "수축",
        이완: "이완",
        측정일: "측정일",
        유효기간: "유효기간",
      };

      const metaValues = Object.keys(metaKeys).reduce((acc, key) => {
        const meta = metas.find((meta) => meta.meta_key === metaKeys[key]);
        acc[key] = meta ? meta.meta_value : "";
        return acc;
      }, {});

      const registerType = metaValues.registerType;
      const field_id = metaValues.field_id;
      const field_name = metaValues.field_name;
      const 담당부서 = metaValues.담당부서;
      const com_name = this.pendingUser.company.com_name ? this.pendingUser.company.com_name : metaValues.com_name ? metaValues.com_name : "";
      const com_number = this.pendingUser.company.com_number ? this.pendingUser.company.com_number : metaValues.com_number ? metaValues.com_number : "";
      const foreignValue = !!(metaValues.foreign && metaValues.foreign === 1);
      const rrn = metaValues.rrn;
      const 직종 = metaValues.직종;
      const 건설업기초안전교육_id = metaValues.건설업기초안전교육_id;
      const 건설업기초안전교육_fileName = metaValues.건설업기초안전교육_fileName;
      const 건설업기초안전교육_fileSize = metaValues.건설업기초안전교육_fileSize;
      const 건설업기초안전교육_path = metaValues.건설업기초안전교육_path;
      const 건설업기초안전교육_thumb = metaValues.건설업기초안전교육_thumb;
      const 교육이수번호 = metaValues.교육이수번호;
      const 신분증 = metaValues.신분증;
      const 장비운전자 = metaValues.장비운전자;
      const 건설기계조종사면허번호 = metaValues.건설기계조종사면허번호;
      const 건설기계조종사면허증 = metaValues.건설기계조종사면허증;

      const 안전교육만료일 = metaValues.안전교육만료일;
      const 작업자안전교육만료일 = metaValues.작업자안전교육만료일;
      const 밀폐공간안전교육만료일 = metaValues.밀폐공간안전교육만료일;
      const 수축 = metaValues.수축;
      const 이완 = metaValues.이완;
      const 측정일 = metaValues.측정일;
      const 유효기간 = metaValues.유효기간;

      this.pendingUser.meta.registerType = registerType;
      this.pendingUser.meta.field = {
        id: isNaN(Number(field_id)) ? 0 : Number(field_id),
        field_name,
      };
      this.pendingUser.meta.담당부서 = 담당부서;
      this.pendingUser.meta.업체 = { com_name, com_number };
      this.pendingUser.meta.isForeigner = foreignValue;
      this.pendingUser.meta.rrn = rrn;
      this.pendingUser.meta.직종 = 직종;
      this.pendingUser.meta.건설업기초안전교육 = {
        id: 건설업기초안전교육_id,
        fileName: 건설업기초안전교육_fileName,
        fileSize: 건설업기초안전교육_fileSize,
        path: 건설업기초안전교육_path,
        thumb: 건설업기초안전교육_thumb,
      };
      this.pendingUser.meta.교육이수번호 = 교육이수번호;
      this.pendingUser.meta.enc.신분증사진 = 신분증;
      this.pendingUser.meta.장비운전자 = 장비운전자 !== "0";
      this.pendingUser.meta.건설기계조종사면허번호 = 건설기계조종사면허번호;
      this.pendingUser.meta.enc.건설기계조종사면허증사진 = 건설기계조종사면허증;

      this.pendingUser.meta.안전교육만료일 = 안전교육만료일;
      this.pendingUser.meta.작업자안전교육만료일 = 작업자안전교육만료일;
      this.pendingUser.meta.밀폐공간안전교육만료일 = 밀폐공간안전교육만료일;
      this.pendingUser.meta.수축 = 수축;
      this.pendingUser.meta.이완 = 이완;
      this.pendingUser.meta.측정일 = 측정일;
      this.pendingUser.meta.유효기간 = 유효기간;

      // // 해당작업을 하지 않으면 사업체명 select 에서 선택된 값이 [object Object]로 나옴
      if (this.pendingUser.meta.field) {
        this.pendingUser.meta.field = this.fieldOptions.find((field) => field.id === this.pendingUser.meta.field.id);
      }
    },

    async loadUser(userId) {
      try {
        this.resetPassword = false;
        const response = await HttpRequest.get(`/api/v1/member/${userId}/detail`);

        if (response) {
          // meta내부에 회원구분, 사업장, 담당부서, 외국인여부, 주소, 직책, 직종,
          // 건설업기초안전교육, 교육이수번호, 업체, 장비운전자, 서명, 건설기계조종사면허번호, enc(신분증사진, 건설기계조종사면허증사진) 추가
          this.pendingUser.id = response.id;
          this.pendingUser.company = response.company;
          this.pendingUser.username = response.username; // 아이디
          this.pendingUser.name = response.name ? response.name : ""; // 이름
          this.pendingUser.phone = response.phone ? response.phone : ""; // 전화번호

          // Split phone number into parts
          if (response.phone && response.phone.length === 11) {
            this.pendingUser.phone1 = response.phone.substring(0, 3);
            this.pendingUser.phone2 = response.phone.substring(3, 7);
            this.pendingUser.phone3 = response.phone.substring(7, 11);
          } else if (response.phone && response.phone.length === 10) {
            this.pendingUser.phone1 = response.phone.substring(0, 3);
            this.pendingUser.phone2 = response.phone.substring(3, 6);
            this.pendingUser.phone3 = response.phone.substring(6, 10);
          }

          this.pendingUser.email = response.email ? response.email : ""; // 이메일
          this.pendingUser.직책 = response.rank ? response.rank : ""; // 직책
          this.pendingUser.서명 = response.signature ? response.signature : ""; // 서명

          this.pendingUser.metas = response.metas;
          this.fixMissingMetaData();

          // this.originPendingUserString = JSON.stringify(this.pendingUser);

          const 교육만료일자 = await applyEducationExpirationToUser(this.$store.dispatch, {
            projectId: this.projectId,
            userId
          });
          const 기본교육만료일자 = 교육만료일자.기본교육만료일 || '';
          const 작업자안전교육만료일자 = 교육만료일자.작업자교육만료일 || '';
          const 밀폐공간안전교육만료일자 = 교육만료일자.밀폐공간교육만료일 || '';
          this.교육만료일.기본안전 = 기본교육만료일자;
          this.교육만료일.작업자 = 작업자안전교육만료일자;
          this.교육만료일.밀폐공간 = 밀폐공간안전교육만료일자;

        } else {
          console.error("Response or response.data is undefined");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    },

    // meta 값을 array 로 변경
    convertMetaToArray(meta) {
      const metas = [];
      for (const key in meta) {
        if (key === "enc") {
          continue;
        }

        if (meta.hasOwnProperty(key)) {
          if (typeof meta[key] === "object" && !Array.isArray(meta[key])) {
            for (const subKey in meta[key]) {
              if (meta[key].hasOwnProperty(subKey)) {
                if (key === "field" && subKey === "id") {
                  metas.push({ key: "field.id", value: String(meta[key][subKey]) });
                  metas.push({ key: "업체.fields[0].id", value: String(meta[key][subKey]) });
                  metas.push({ key: "업체.fields[0].pivot.field_id", value: String(meta[key][subKey]) });
                  metas.push({ key: "업체.fields[0].pivot.company_id", value: String(meta[key][subKey]) });
                } else if (key === "field" && subKey === "field_name") {
                  metas.push({ key: "field.field_name", value: String(meta[key][subKey]) });
                  metas.push({ key: "업체.fields[0].field_name", value: String(meta[key][subKey]) });
                } else {
                  metas.push({ key: `${key}.${subKey}`, value: String(meta[key][subKey]) });
                }
              }
            }
          } else if (key === "장비운전자") {
            metas.push({ key, value: meta[key] ? "1" : "0" });
          } else {
            metas.push({ key, value: String(meta[key]) });
          }
        }
      }

      return metas;
    },

    async loadEditAccount(userId) {
      let result = false;
      const params = {
        name: this.pendingUser.name,
        email: this.pendingUser.email,
        rank: this.pendingUser.직책,
        metas: this.convertMetaToArray(this.pendingUser.meta),
        reset_password: this.resetPassword ? this.resetPassword : undefined,
      };
      if (this.pendingUser.meta.업체.id) {
        params.company_id = this.pendingUser.meta.업체.id;
      }

      await HttpRequest.post(`/api/v1/member/${userId}`, params)
        .then((response) => {
          if (response) {
            this.$toast.success("변경사항이 저장되었습니다.");
            result = true;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err);
            if (err.response.data) {
              console.log("errResponse", err.response.data);
            }
          }
          this.$toast.error("저장 중 오류가 발생했습니다.");
        });

      if (result) {
        await this.loadUser(this.getId).then((response) => {
          this.originPendingUserString = JSON.stringify(this.pendingUser);
          this.updateEditMode();
        });
      }
    },

    async removeUser(userId) {
      let result = false;
      await HttpRequest.delete(`/api/v1/member/${userId}`, {})
        .then((response) => {
          if (response) {
            this.$toast.success("회원이 삭제되었습니다.");
            result = true;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err);
            if (err.response.data) {
              console.log("errResponse", err.response.data);
            }
          }
          this.$toast.error("삭제 중 오류가 발생했습니다.");
        });

      if (result) {
        this.$router.push({
          name: "page-regist-account-list",
          query: this.$route.query,
        });
      }
    },

    async onClickResetPassword() {
      this.resetPassword = !this.resetPassword;
      if (this.resetPassword) {
        this.editMode = true;
        this.$toast.warning("저장 후 비밀번호가 아이디와 동일하게 초기화됩니다.");
      } else {
        this.$toast.info("비밀번호 초기화가 취소되었습니다.");
      }
      this.updateEditMode();
    },

    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "회원삭제",
          message: msg,
          useConfirm: true,
          confirmBtn: "확인",
          cancelBtn: "취소",
          confirmFunction: () => this.removeUser(this.getId),
          cancelFunction: () => {},
        },
      });
      window.dispatchEvent(customAlert);
    },

    inputMeasurementDate(data) {
      const originalDate = new Date(data);
      originalDate.setFullYear(originalDate.getFullYear() + 1);

      this.pendingUser.meta.유효기간 = originalDate.toISOString().slice(0, 10);
    },
    updateEditMode() {
      if (this.originPendingUserString !== "") {
        const originalData = JSON.parse(this.originPendingUserString);
        if (!this.deepEqual(originalData, this.pendingUser) || this.resetPassword) {
          this.editMode = true;
        } else {
          this.editMode = false;
        }
      }
    },
    deepEqual(obj1, obj2, path = "") {
      if (obj1 === obj2) return true;

      if (obj1 == null || obj2 == null) {
        console.log(`다른부분 [${path}]: null/undefined 차이`, { obj1, obj2 });
        return false;
      }

      if (typeof obj1 !== typeof obj2) {
        console.log(`다른부분 [${path}]: 타입 차이`, { obj1: typeof obj1, obj2: typeof obj2 });
        return false;
      }

      if (typeof obj1 !== "object") {
        if (obj1 !== obj2) {
          console.log(`다른부분 [${path}]: 값 차이`, { obj1, obj2 });
        }
        return obj1 === obj2;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      // if (keys1.length !== keys2.length) {
      //   console.log(`다른부분 [${path}]: 키 개수 차이`, { keys1: keys1.length, keys2: keys2.length });
      //   return false;
      // }

      for (let key of keys1) {
        if (!keys2.includes(key)) {
          console.log(`다른부분 [${path}]: 키 누락`, { missingKey: key });
          return false;
        }

        const currentPath = path ? `${path}.${key}` : key;
        if (!this.deepEqual(obj1[key], obj2[key], currentPath)) {
          return false;
        }
      }

      return true;
    },
  },
  watch: {
    pendingUser: {
      deep: true,
      handler(newValue) {
        this.updateEditMode(newValue);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div {
      border-bottom: 1px solid #e0e0e0;
    }
    & > div:hover {
      background-color: #f5f5f5;
      color: #000;
      font-weight: bold;
    }
    & > div.active {
      background-color: #7e72f299;
      color: #fff;
    }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}

.align-center {
  align-items: center;
}
.success-color {
  color: #28c76f;
}
.alert-color {
  color: #ea5455;
}
.input-button {
  height: 37.5px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}

.grid-item {
  align-self: start;
  grid-column: span 2;
}

@media (min-width: 768px) {
  .grid-item {
    align-self: start;
    grid-column: span 1;
  }
}
</style>
